import { render, staticRenderFns } from "./WaitingSubmission.vue?vue&type=template&id=3665c9ab&scoped=true"
import script from "./WaitingSubmission.vue?vue&type=script&lang=js"
export * from "./WaitingSubmission.vue?vue&type=script&lang=js"
import style0 from "./WaitingSubmission.vue?vue&type=style&index=0&id=3665c9ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665c9ab",
  null
  
)

export default component.exports